import { createStore, combineReducers, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './reducers/authReducer';
import categoryReducer from './reducers/categoryReducer';
import songModelsReducer from './reducers/songModelsReducer';
import logReducer from './reducers/logReducer';
import productReducer from './reducers/productReducer';
import taskReducer from './reducers/taskReducer';
import syncReducer from './reducers/syncReducer';
import certificateReducer from './reducers/certificateReducer';
import coinTaskReducer from './reducers/coinTaskReducer';
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'] // only auth will be persisted
};

const rootReducer = combineReducers({
  auth: authReducer,
  songModels: songModelsReducer,
  categories: categoryReducer,
  log: logReducer,
  products: productReducer,
  tasks: taskReducer,
  coinTasks: coinTaskReducer,
  sync: syncReducer,
  certificates: certificateReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Custom middleware to handle async actions
const asyncMiddleware = () => next => action => {
  if (typeof action === 'function') {
    return action(next);
  }
  return next(action);
};

const store = createStore(
  persistedReducer,
  applyMiddleware(asyncMiddleware),
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const persistor = persistStore(store);

export { store, persistor }; 